import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { GenericWrapper, CursorPointerWrapper, Mt3, WhiteSpaceNoWrap, Mt2 } from 'wrappers';
import { SecondaryTextSm300, SecondaryTextBaseBold, SecondaryTextBase } from 'atoms';
import internalState from './internalState';

export const definition = {
  name: 'InfoBox',
  controller: Controller,
  initialProps: ({ infoBox }) => ({ infoBox }),
  props: internalState,
  elements: [
    {
      wrapper: wrap(GenericWrapper, CursorPointerWrapper),
      name: 'Wrapper',
      isButton: true,
      bindings: ({ isytd }) => ({ isytd }),
      elements: [
        {
          component: wrap(SecondaryTextSm300, WhiteSpaceNoWrap),
          name: 'Title',
          displayValue: ({ infoBox, isytd }) => isytd ? `${infoBox.title} YTD` : `${infoBox.title} MTD`
        },
        {
          component: wrap(SecondaryTextBaseBold, Mt3),
          name: 'Value',
          displayValue: ({ infoBox, isytd }) => {
            if (isytd) {
              return `$${parseFloat(infoBox.ytd?.amount ? (infoBox.ytd?.amount ?? 0) : (infoBox.ytd ?? 0)).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
            } else {
              return `$${parseFloat(infoBox.mtd?.amount ? (infoBox.mtd?.amount ?? 0) : (infoBox.mtd ?? 0)).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
            }
          }
        },
        {
          component: wrap(wrap(SecondaryTextBase, WhiteSpaceNoWrap), Mt2),
          name: 'Name',
          renderIf: ({ infoBox, isytd }) => isytd ? !!infoBox.ytd?.name : !!infoBox.mtd?.name,
          displayValue: ({ infoBox, isytd }) => isytd ? infoBox.ytd?.name : infoBox.mtd?.name
        },
      ]
    }
  ]
}

export default ContainerComponent(definition)